import { TableBody } from '@mui/material';

const SortablePaginationTableBody = TableBody
// @ts-ignore
SortablePaginationTableBody.displayName = 'SortablePaginationTableBody'
export default SortablePaginationTableBody
